<div class="container">
  <h2 class="text-center">Book a show!</h2>
  <div class="card m-1 m-md-5" data-aos="fade-down">
    <div class="card-header text-center">
      <h3>Contact us here!</h3>
    </div>
    <div class="card-body">
      <p class="card-text text-center">
        <strong>Based in</strong> <br />
        Landen, Belgium <br />
        <strong>Email</strong> <br />
        <a href="mailto:contact&#64;argon.band">contact&#64;argon.band</a>
        <br />
        <strong>Phone</strong> <br />
        <a href="tel:+32499146182">+32 499 156 182</a>
      </p>
    </div>
  </div>
</div>